import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterModule],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
  host: {
    class: 'flex flex-col flex-1 w-full',
  },
})
export class Layout implements OnInit {
  private router = inject(Router);
  public currentUrl = signal(this.router.url);

  @Input()
  title: string = '';

  @Input()
  client: string = '';
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.set(event.urlAfterRedirects);
      }
    });
  }

  confirmExit(event: Event) {
    const ok = confirm('Vous allez perdre toutes les informations rentrées dans le formulaire.');
    if (!ok) {
      event.preventDefault(); // Annule la redirection du routerLink si l'utilisateur clique sur "Annuler"
    }
  }
}
